export default "__VITE_ASSET__iadn$$Et__"